<template>
  <div>
    <jurisdiction-form
      @jurisdictionWay="jurisdictionWay"
      :nameError="nameError"
    ></jurisdiction-form>
  </div>
</template>

<script>
import jurisdictionForm from './jurisdictionForm'
import { getAddJurisdiction, getEditJurisdiction, checkJurisdictionName } from '@/api/app'
export default {
  name: 'add-jurisdiction',
  data() {
    return {
      nameError: ''
    }
  },
  created() {
    if (this.$route.name === 'addJurisdiction') {
      this.$store.dispatch('setPage', { title: '新增权限组', type: 'edit-container' })
    } else {
      this.$store.dispatch('setPage', { title: '编辑权限组', type: 'edit-container' })
    }
  },
  components: { jurisdictionForm },
  methods: {
    jurisdictionWay(data) {
      checkJurisdictionName({
        gname: data.name,
        gid: data.gid
      }).then(res => {
        if (res.code === 0) {
          if (res.result === 'true') {
            this.save(data)
          } else {
            this.nameError = '权限分组名已被使用'
          }
        }
      })
    },
    save(data) {
      if (this.$route.name === 'addJurisdiction') {
        getAddJurisdiction({
          gadmin: data.name,
          limits: data.limits
        }).then(res => {
          this.handle(res)
        })
      } else {
        getEditJurisdiction({
          gid: data.gid,
          gname: data.name,
          limits: data.limits
        }).then(res => {
          this.handle(res)
        })
      }
    },
    handle(res) {
      if (res.code === 0) {
        localStorage.removeItem('isNull')
        this.$router.push({ name: 'jurisdictionSet' })
      } else if (res.code !== 10008) {
        this.$Message.info(res.msg)
      }
    }
  }
}
</script>

<style scoped>
  .card-container {
    width: 100%;
  }
  .content-top,.content-bottom {
    padding: 30px 20px;
    background: rgba(255,255,255,1);
    box-shadow: 0 4px 8px 1px rgba(135,150,176,0.09);
  }
  .content-top {
    margin-bottom: 10px;
  }
</style>
